import { Expose } from 'class-transformer';

import { Model } from 'src/app/core/data/model';



export class PushNotificationData extends Model {
  @Expose() payload?: any;
}
